import { storeGuestDeliveryLocation } from 'helpers/StorageHelper';
import React, { Suspense, useCallback } from 'react';
import { guestDeliveryFFLModalOpenSelector } from 'store/customer/selectors/CustomerGlobalSelectors';
import { setCheckoutSelectedShippingFfl } from 'store/customer/slices/CustomerCheckoutSlice';
import {
  setGuestDeliveryFFLModalOpen,
  setSelectedDeliveryAddress,
} from 'store/customer/slices/CustomerGlobalSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const AddEditAddressModal = React.lazy(
  () => import('../../subModules/CustomerProfile/GeneralProfile/Modals/AddEditAddressModal')
);

/**
 * Logged-out counterpart of {@link ../Modals/DeliveryLocationModal}. Guests have no
 * address book, so the header "Deliver to" block opens a guest version of the address modal.
 * The chosen location is saved in memory.
 */
export default function GuestDeliveryFFLModal() {
  const dispatch = useAppDispatch();
  const showModal = useAppSelector(guestDeliveryFFLModalOpenSelector);

  const handleCloseModal = useCallback(() => {
    dispatch(setGuestDeliveryFFLModalOpen(false));
  }, [dispatch]);

  const handleAddressSubmit = useCallback(
    (success: boolean, data?: any) => {
      if (success && data) {
        dispatch(setSelectedDeliveryAddress(data));
        dispatch(setCheckoutSelectedShippingFfl(data.selected_ffl || null));
        storeGuestDeliveryLocation(data);
        handleCloseModal();
      }
    },
    [dispatch, handleCloseModal]
  );

  if (!showModal) return null;

  return (
    <Suspense fallback={null}>
      <AddEditAddressModal
        show={showModal}
        onHide={handleCloseModal}
        onSubmit={handleAddressSubmit}
        isGuest={true}
      />
    </Suspense>
  );
}
